document.addEventListener('DOMContentLoaded', () => {
  const targetNode = document.querySelector('.cart-page .ajax-cart__form-wrapper.cart-wrapper');

  if (targetNode) {
    const observer = new MutationObserver(function(mutationsList) {
      for (const mutation of mutationsList) {
        if (
          mutation.type === 'childList' &&
          mutation.target.classList?.contains('cart-price') &&
          mutation.target.classList?.contains('cart-original-total') &&
          mutation.target.classList?.contains('js-cart-subtotal')
        ) {
          BSS_B2B.observer.cartSubject.listenCartCheckout();
        }
      }
    });

    const config = {
      childList: true,
      subtree: true,
    };

    observer.observe(targetNode, config);
  }
});
